import { useEffect, useState } from 'react';

import { parseHandoutDate } from './handoutDate';

import type { HandoutPreviewData } from '@/types/review/ReviewDiscussion';

export const useHandoutEvaluationPeriod = (handoutData: HandoutPreviewData | undefined) => {
    const [selectedPeriodId, setSelectedPeriodId] = useState('');
    const [customFromDate, setCustomFromDate] = useState<Date | undefined>(undefined);
    const [customToDate, setCustomToDate] = useState<Date | undefined>(undefined);

    useEffect(() => {
        if (!handoutData) {
            return;
        }

        setSelectedPeriodId(handoutData.evaluationPeriodId ?? 'custom');

        if (handoutData.evaluationStartDate) {
            setCustomFromDate(parseHandoutDate(handoutData.evaluationStartDate));
        }
        if (handoutData.evaluationEndDate) {
            setCustomToDate(parseHandoutDate(handoutData.evaluationEndDate));
        }
    }, [
        handoutData?.evaluationPeriodId,
        handoutData?.evaluationStartDate,
        handoutData?.evaluationEndDate,
    ]);

    return {
        selectedPeriodId,
        customFromDate,
        customToDate,
    };
};
